module.exports = __webpack_public_path__ + "static/media/activity-log.0ef03468.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/dashboard-icons/activity-log.svg
// module id = 2122
// module chunks = 0